const filtersModulesData = {
    artists: "artists",
    distributions: "distributions",
    driveManagement: "driveManagement",
    releases: "releases",
    revenueReports: "revenueReports",
    tracks: "tracks",
    videos: "videos",
};

export default filtersModulesData;
